import { useParams } from "@solidjs/router";
import { useSFetch } from "../hooks/sfetch";
import { useToast } from "../components/MessageBox";
import { useNavigate } from "@solidjs/router";
import Text from "../components/Text";
import { useTranslation } from "../hooks/useTranslation";


export function ActivateMinecraftSession() {

    const navigate = useNavigate();
    const params = useParams();
    const sfetch = useSFetch();
    const toast = useToast();
    const { t } = useTranslation();

    async function activateCode() {
        await sfetch("/api/GrantedUsers/ActivateConnectionCode", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                code: params.code,
            }),
        }).then((response) => {
            if (response.ok) {
                toast?.info("Session verified");
                navigate("/activationdone");
            }
            else {
                toast?.error(t("VERIFY_CODE_REJECTED"));
            }
        });
    }

    return (
        <div class="centered">
            <div class="form">
                <h1><Text val="ACTIVATE_MINECRAFT_SESSION" /></h1>
                <div class="security-warning">
                    <i class="fa-solid fa-exclamation-triangle security-warning-icon"></i>
                    <div class="security-warning-text">
                        <strong><Text val="SECURITY_WARNING" /></strong>
                    </div>
                </div>
                <p><Text val="ADDON_CONNECTION_INFO" /></p>
                <button class="btn btn-primary" onClick={activateCode}><Text val="ACTIVATE" /></button>
            </div>
        </div>
    );
}